(() => {
	angular.module('main').directive('snHeader', snHeader);

	snHeader.$inject = ['accountService'];

	function snHeader(accountService) {
		return {
			template: require('./header.component.html'),
			replace: true,
			scope: true,
			link(scope) {
				scope.navbar = null;
				accountService.navDataObservable.subscribe(data => {
					scope.navbar = data.menu_path;
					if (data.menu_path === null) {
						scope.navbar = 'companyUser';
					}
				});
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/navigation/header/header.component.js